/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { SwitchProps } from '../../../types/InputComponentProps';
import { Checkbox, Field, Stack } from 'chakra-v3';
import { Text } from '../../../../../components/Index';

export function BooleanInput(props: SwitchProps) {
  const {
    id,
    label,
    isInvalid,
    isDisabled,
    isChecked,
    size: _size,
    className,
    onChange,
    description,
    error: _error,
    isRequired: _isRequired,
    ...rest
  } = props;
  return (
    <Field.Root id={id} invalid={isInvalid} disabled={isDisabled} className={className}>
      <Checkbox.Root
        id={id}
        checked={isChecked}
        disabled={isDisabled}
        borderColor="border.teal"
        alignItems={'flex-start'}
      >
        <Checkbox.HiddenInput {...rest} onChange={onChange} />
        <Checkbox.Control>
          <Checkbox.Indicator />
        </Checkbox.Control>
        <Checkbox.Label asChild>
          <Stack alignItems={'flex-start'} mt={'-6px'} gap={'3px'}>
            <Text variant="body" fontWeight={'medium'} color="text.primary">
              {label}
            </Text>
          </Stack>
        </Checkbox.Label>
      </Checkbox.Root>
      {description && (
        <Field.HelperText color="text.primary" opacity={0.8} fontSize="sm">
          {description}
        </Field.HelperText>
      )}
    </Field.Root>
  );
}
